module.exports = "<div fxLayout fxLayoutGap=\"20px\" fxLayoutAlign=\"start center\">\r\n  <img src=\"./assets/img/stepper-vertical/{{img}}\">\r\n  <div style=\"display: flex;\">\r\n    <p class=\"title-text-modal\">{{text}}</p>\r\n    <p class=\"subtitle-text-modal\">{{subtitle}}</p>\r\n  </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/title-modal/title-modal.component.html
// module id = ../../../../../src/app/components/title-modal/title-modal.component.html
// module chunks = main